import { PAYMENT_REQUEST_SUCCESS } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case PAYMENT_REQUEST_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};
